export const PRODUCT_RAIN_COLLAR = {
  label: 'Rain Collar',
  value: 'PRODUCT_RAIN_COLLAR'
};
export const PRODUCT_WOOD_TRIM = {
  label: 'Wood Trim',
  value: 'PRODUCT_WOOD_TRIM'
};
